import {Component, Mixins, Watch} from 'vue-property-decorator';
import LoadingMixin from '@/mixins/LoadingMixin';
import BusinessPanel from '@/products-and-services/BusinessPanel.vue';
import ServiceTypesView from '@/products-and-services/ServiceTypesView.vue';
import ShoppingCart from '@/products-and-services/MiniCart.vue';
import FiberComingSoon from '@/products-and-services/FiberComingSoon.vue';
import MobileShoppingCart from '@/products-and-services/MobileMiniCart.vue';
import {BusinessResidence} from '@/products-and-services/ProductsAndServicesModels';
import BreadCrumb from '@/components/bread-crumb/BreadCrumb.vue';
import ProductsServicesMixin from '@/mixins/ProductsServicesMixin';
import ThemeMixin from "@/mixins/ThemeMixin";
import WrongServiceCartModal from "@/components/WrongServiceCartModal.vue";
import BusinessResidenceMixin from "@/mixins/BusinessResidenceMixin";
import Modal from "@/components/Modal.vue";

@Component({
    components: {
        BusinessPanel,
        ServiceTypesView,
        ShoppingCart,
        MobileShoppingCart,
        BreadCrumb,
        FiberComingSoon,
        WrongServiceCartModal,
        Modal
    }
})
export default class ProductsAndServices extends Mixins(LoadingMixin, ProductsServicesMixin, ThemeMixin, BusinessResidenceMixin) {
    selectedTab = 'home';
    tabs = ['home', 'business'];
    layout = 'grid';
    serviceTypeIdsWithError: string[] = [];
    showModal = false;
    @Watch("$store.state.shoppingCartData.errors")
    doErrorsExist(){

        // reset array if no errors
        if (this.$store.state.shoppingCartData.errors.length === 0) {
            this.serviceTypeIdsWithError = [];
        }
    }

    get submittedText() {
        if (this.$store.getters.getIsCustomer){
            return 'Your Shopping Cart has been submitted.';
        } else {
            return 'This Shopping Cart has already been submitted.';
        }
    }

    get fiberComingSoon(): boolean {
        // show this when service address does not have any available options or is in region 5 or if they say their address isn't displayed on the site.
        if (!this.$store.state.loadingCart && (!this.hasAvailableOptions || this.$store.state.shouldShowFiberComingSoon)) {
            return true;
        }
        return false;
    }

    get userInWrongServiceArea() {
        if (this.$store.state.isEmployee || (this.$route.query.employee && this.$route.query.employee === 'true')) {
            const employeeNeedsToConfirmServiceType = false;
            return employeeNeedsToConfirmServiceType;
        }

        if (window.location.pathname.includes('residential') && !this.$store.getters.isCartEmpty) {
            return this.$store.state.shoppingCartData.businessResidence && this.$store.state.shoppingCartData.businessResidence !== BusinessResidence.Residence;
        }

        if (window.location.pathname.includes('business') && !this.$store.getters.isCartEmpty) {
            return this.$store.state.shoppingCartData.businessResidence && this.$store.state.shoppingCartData.businessResidence !== BusinessResidence.Business;
        }
    }

    get hasAvailableOptions(): boolean {
        return this.$store.state.shoppingCartData.availableOptions && this.$store.state.shoppingCartData.availableOptions.serviceTypes.length > 0;
    }

    get showSpinner(): boolean {
        return this.$store.state.loadingCart;
    }

    get isSubmitted(): boolean {
        return this.$store.state.shoppingCartData.submitted || false;
    }

    get isCurrentPageRootLevel () {
        return this.$route.meta && this.$route.meta.isHome
    }

    get isCurrentPageCartReview () {
        return this.$route.meta && this.$route.meta.isCartReview
    }

    get flexAttributesToApply(): object {
        return {'--flex-direction': 'row-reverse', '--align-items': 'flex-start'}
    }

    private setBusinessResidentialWhenNull() {
        if (!this.$store.state.shoppingCartData.businessResidence) {
            this.setBusinessResidenceBasedOnCurrentPage();
        }
    }

    async created() {
        if (!this.userInWrongServiceArea || this.$store.getters.isCartEmpty) {
            this.setBusinessResidentialWhenNull();
            await this.loadShoppingCart();
       }
    }

    async loadShoppingCart() {
        await this.execute(async () => {
            const token = this.$route.query.token || undefined;
            const cartId = this.$route.query.cartId || undefined;
            const isEmployee = this.$route.query.employee === 'true';
            const submitted = this.$store.state.shoppingCartData.submitted;
            await this.$store.dispatch('loadShoppingCart', {cartId, token, isEmployee, forceClear: submitted});
        }, 'Failed to retrieve shopping cart data');
    }

    storeServiceTypeIdWithError(value: string) {
        this.serviceTypeIdsWithError.push(value);
    }
}
